import axios from 'axios';

// const API_BASE_URL ='http://localhost:8080/api'; //<-develop
const API_BASE_URL = 'https://api.testowa.win/api'; //<-produkcja 


const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;